import getNumberOfSharingLinks from './selectors/getNumberOfSharingLinks';
import getSharingDataFromLink from './selectors/getSharingData';
import getSharingLink from './selectors/getSharingLink';
import SharingLinkInfo from './store/schema/SharingLinkInfo';
import { LinkActionStatus } from './types/LinkActionStatus';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "LinkData", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded public actions
export const lazyUpdateHasDLRecipient = new LazyImport(lazyModule, m => m.updateHasDLRecipient);
export const lazyAddRecipientsIntoLink = new LazyImport(lazyModule, m => m.addRecipientsIntoLink);
export const lazyRemoveRecipientsFromLink = new LazyImport(
    lazyModule,
    m => m.removeRecipientsFromLink
);
export const lazyUpdateRecipientPermissionInfo = new LazyImport(
    lazyModule,
    m => m.updateRecipientPermissionInfo
);
export const lazyIgnoreSharingTip = new LazyImport(lazyModule, m => m.ignoreSharingTip);

// Delay loaded utility functions
export const lazyGetSharingTipRecipientInfo = new LazyImport(
    lazyModule,
    m => m.getSharingTipRecipientInfo
);

//boot strap - used to load the package, in cases where an action might be fired off before the package is loaded,
// but the action is subbscribed to by other packages, so it can't be lazy loaded directly.
export const lazyLinkBootStrap = new LazyImport(lazyModule, m => m.linkBootStrap);

// Non-delay loaded subscribable actions
export { addSharePointLink, removeSharingLink } from './actions/subscribableActions';

// Note - these are actions that are not lazy loaded, and should
// only be consumed by owa-compose-view. They act like internal actions, but
// due to store/view being in different packages must be exported.
export {
    updateSharingLinkFromSharingDialog,
    updateSharePointLinkPermission,
    updateSharePointLinkUrl,
    setRefreshStatus,
    createSharingLink,
} from './actions/internalActions';

// exported constants and types
export { LinkActionStatus, SharingLinkInfo };

// non-delay loaded selectors - TODO make lazy
export { getNumberOfSharingLinks, getSharingDataFromLink, getSharingLink };
